import { __decorate } from 'tslib';
import { Pipe, NgModule } from '@angular/core';
import { orderBy } from 'lodash';

let SortByPipe = class SortByPipe {
    transform(value, order = '', column = '') {
        if (!value || order === '' || !order) {
            return value;
        } // no array
        if (!column || column === '') {
            if (order === 'asc') {
                return value.sort();
            }
            else {
                return value.sort().reverse();
            }
        } // sort 1d array
        if (value.length <= 1) {
            return value;
        } // array with only one item
        return orderBy(value, [column], [order]);
    }
};
SortByPipe = __decorate([
    Pipe({ name: 'sortBy' })
], SortByPipe);

let NgpSortModule = class NgpSortModule {
};
NgpSortModule = __decorate([
    NgModule({
        declarations: [SortByPipe],
        exports: [SortByPipe]
    })
], NgpSortModule);

/*
 * Public API Surface of ngp-sort
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgpSortModule, SortByPipe };
//# sourceMappingURL=ngp-sort-pipe.js.map
